module.exports = require("./kok-IN.js");